import React, { useState } from 'react';
import InputField from "components/fields/InputField";
import Loader from "components/Loader/Loader";
import { useNavigate } from 'react-router-dom';
import {handleEncrypt} from "../../utils/AesUtil";

import jwt from 'jwt-decode';

export default function SignIn() {
  const navigateTo = useNavigate();
  const [errorMessages, setErrorMessages] = useState({});
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleInputChange = (event) => {
    errorMessages.message = "";
    setEmailError(false);
    setPasswordError(false)
    const { id, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const renderErrorMessage = (name) =>
      name === errorMessages.name && (
          <div className="text-red-500">{errorMessages.message}</div>
      );

  const errors = {
    email: "Por favor introduza um e-mail válido",
    password: "Por favor, introduza a senha",
    invalidCredentials: "E-mail ou palavra-passe inválida",
  };

  const handleSignIn = async () => {
    let { email, password } = { ...formData };
    if (email === "" || email === undefined || !emailRegex.test(email)) {
      setEmailError(true);
      setErrorMessages({ name: "email", message: errors.email });
    } else if (password === "" || password === undefined) {
      setPasswordError(true);
      setErrorMessages({ name: "password", message: errors.password });
    } else {
      setLoading(true);

      try {
        const encrypted = await handleEncrypt(password);
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: email,
            password: encrypted,
            userAgent: navigator.userAgent
          }),
        };

        fetch(process.env.REACT_APP_API_URL + "/v1/login", requestOptions)
            .then((response) => response.json())
            .then((data) => {
              setLoading(false);
              if (data.responseInfo.status === "SUCCESS") {
                const decodedToken = jwt(data.data.token);
                const authority = decodedToken.authority;
                localStorage.setItem('token', data.data.token);
                if (data.data.changePassword === true) {
                  console.log("redirect to change password");
                  alert('change password')
                  // navigateTo("../more-detail");
                } else {
                  switch (authority) {
                    case "USER":
                      navigateTo("/user/default");
                      break;
                    default:
                      navigateTo("/user/default");
                  }
                }
              } else {
                setErrorMessages({
                  name: "invalidCredentials",
                  message: errors.invalidCredentials,
                });
              }
            }).catch((error) => {
          console.log(error);
        });
      } catch (error) {
        setLoading(false);
        console.error('Encryption error:', error);
      }
    }

  };

  return (
    <div className="mt-16 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center">
      <Loader show={loading} />
      {/* Sign in section */}
      <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          Entrar
        </h4>
        <p className="mb-9 ml-1 text-base text-gray-600">
          Introduza o seu e-mail e palavra-passe para entrar!
        </p>

        {renderErrorMessage("invalidCredentials")}
        {renderErrorMessage("email")}
        {renderErrorMessage("password")}

        {/* Email */}
        <InputField
            variant="auth"
            extra="mb-3"
            label="Email*"
            placeholder="mail@example.com"
            id="email"
            type="email"
            state={emailError ? "error" : ""}
            value={formData.email}
            onChange={handleInputChange}
        />

        {/* Password */}
        <InputField
            variant="auth"
            extra="mb-3"
            label="Password*"
            placeholder="Password"
            id="password"
            type="password"
            state={passwordError ? "error" : ""}
            value={formData.password}
            onChange={handleInputChange}
        />
        {/* Checkbox */}
        <div className="mb-4 flex items-center justify-between px-2">
          
          <a
            className="text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
            href=" "
          >
            Forgot Password?
          </a>
        </div>
        <button className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200" onClick={handleSignIn}>
          Sign In
        </button>
      </div>
    </div>
  );
}
